var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElementButton',{attrs:{"name":"download","i18n":"","content":_vm.content,"state":_vm.partState,"data-url":"command://noOp"},on:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }